import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { CryptoTransaction } from "@models/transaction";
import { CryptocoinsState } from "@modules/+new/payments/shared-payments/services/cryptocoins-state.service";
import { EMPTY, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ModalService } from "@core-services/modal.service";
import { AccountService } from "@modules/account/services/account.service";
import { SendTrackingFacade } from "@modules/main/components/step-summary/sending-modal/services/send-tracking.facade";

@Component({
	selector: "send-multichain-money-on-way",
	templateUrl: "./send-multichain-money-on-way.component.html",
	styleUrls: ["./send-multichain-money-on-way.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SendMultichainMoneyOnWayComponent implements OnInit {
	@Input() cryptoTransaction: CryptoTransaction = null;
	public networkName: Observable<string> = EMPTY;
	public defaultFiatSymbol: string = "";

	constructor(
		private readonly cryptocoinState: CryptocoinsState,
		private readonly modalService: ModalService,
		private readonly accountServie: AccountService,
		private readonly trackingService: SendTrackingFacade
	) {}

	ngOnInit(): void {
		this.networkName = this.cryptocoinState.cryptocoins.pipe(
			map((list) => {
				const cryptocoin = list.filter(
					(crypto) => crypto.cryptocoin_id.toString() === this.cryptoTransaction.getCryptocoinId()
				)[0];
				const networkName = cryptocoin.networks.find(
					(network) => network.coin_network_id === this.cryptoTransaction.getCoinNetworkId()
				).name;
				this.trackingService.trackSuccessScreenViewed(cryptocoin.symbol.toUpperCase(), networkName);
				return networkName;
			})
		);
		this.defaultFiatSymbol = this.accountServie.getDefaultFiat().getSymbolCharacter();
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public done(): void {
		this.onCancelButtonClick();
	}
}
